<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/qzzp.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/qzzp_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>求职</span><span style="color:#D7230C;">招聘</span></div>
							<div class="sm_pub">海量职位/人才</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">求职招聘</div>
				</div>
				<div class="Bigcosousuo">
					<el-select v-model="searchData.type" placeholder="请选择" style="width: 25%;float: left;">
						<el-option style="height:40px;" v-for="item in options" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<input v-model="keyword" type="text" placeholder="请输入内容">
					<div @click="selectChild1">
						搜索
					</div>
				</div>
				<div class="rwdt_fb_0" @click="qwqe">我要找工作</div>
				<div class="rwdt_fb" @click="qwqe">我要招聘</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div style="width: 97%;height: 170px;margin-left: 1%;">
					<div style="width: 100%;height: 80px;border-bottom: 1px solid #000;">
						<ul style="padding: 20px;margin: 0;width: 100%;height: 80px;">
							<li style="list-style: none;width: 80px;height: 40px;text-align: center;line-height: 40px;float: left;">筛选：</li>
							<li style="list-style: none;width: 100px;height: 40px;float: left;">
								<el-select v-model="dwgmData" placeholder="单位规模" @change="dwgmDataselect">
									<el-option v-for="item in selectchildList[0].options" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</li>
							<li style="list-style: none;width: 100px;height: 40px;float: left;margin-left: 10px;">
								<el-select v-model="gzxzData" placeholder="工作性质" @change="gzxzDataselect">
									<el-option v-for="item in selectchildList[1].options" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</li>
							<li style="list-style: none;width: 100px;height: 40px;float: left;margin-left: 10px;">
								<el-select v-model="xlyqData" placeholder="学历要求" @change="xlyqDataselect">
									<el-option v-for="item in selectchildList[2].options" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</li>
							<li style="list-style: none;width: 100px;height: 40px;float: left;margin-left: 10px;">
								<el-select v-model="gzjyData" placeholder="工作经验" @change="gzjyDataselect">
									<el-option v-for="item in selectchildList[3].options" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</li>
							<li style="list-style: none;width: 100px;height: 40px;float: left;margin-left: 10px;">
								<el-select v-model="gxsjData" placeholder="更新时间" @change="gxsjDataselect">
									<el-option v-for="item in selectchildList[4].options" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</li>
							<li style="list-style: none;width: 100px;height: 40px;float: left;margin-left: 10px;">
								<el-select v-model="zhpxData" placeholder="招聘职位选项" @change="zhpxDataselect">
								    <el-option
								        v-for="item in selectchildList[5].options"
								        :key="item.value"
								        :label="item.label"
								        :value="item.value">
								    </el-option>
								</el-select>
							</li>
							<!-- <li style="list-style: none;width: 400px;height: 40px;float: left;margin-left: 10px;">
								 <v-distpicker 
								        :province="province" 
								        :city="city" 
								        :area="area"
								        @selected="onSelected">
								    </v-distpicker>
							</li> -->
							<el-select style="width: 150px;float: left;height: 40px;margin-left: 10px;" v-model="selectProv" placeholder="请选择省份"
								v-on:change="getProv($event)">
								<el-option v-for="item in provs" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
							<el-select style="width: 150px;float: left;height: 40px;margin-left: 10px;" v-if="selectProv!=''" v-model="selectCity"
								placeholder="请选择城市" v-on:change="getCity($event)">
								<el-option v-for="item in citys" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</ul>
					</div>
					
					<div style="width: 100%;height: 80px;border-bottom: 1px solid #000;">
						<ul style="padding: 20px;margin: 0;width: 100%;height: 40px;">
							<li style="list-style: none;width: 100px;height: 40px;text-align: center;line-height: 40px;float: left;">已选条件：</li>
							<li class="cnmlgb" style="list-style: none;width: 900px;height: 40px;float: left;">
								<el-tag v-for="(tag, index) in tags" :key="index" closable :type="tag.type" @close="handleClose(tag)">
									<span class="title" style="color: #000;">{{ tag.title }}</span>
									<span>：</span>
									<span>{{ tag.name }}</span>
								</el-tag>
							</li>
						</ul>	
					</div>
				</div>

				<div style="width: 100%;height: 1300px;">
					<router-link tag="div" :to="{ path:'/qzzpdetail',query:{id:item.id,title:item.title} }"  v-for="(item,index) in dabing" :key="index"
						style="width: 97%;margin-top: 10px;margin-left: 1%;border: 1px solid #ececec;height: 150px;position: relative;">
						<div style="height: 30px;font-size: 20px;font-weight: 800;margin-top: 10px;margin-left: 10px;">
							{{item.title}}
						</div>
						<div style="height: 30px;margin-left: 10px;margin-top: 10px;">
							{{item.title}} <img src="../../../imges/rz.png" alt=""
								style="width: 18px;height: 20px;margin-left: 10px;margin-right: 10px;" /> {{item.scope}}
						</div>
						<div style="height: 30px;font-size: 14px;margin-top: 10px;margin-left: 10px;">
							经验：{{item.jinyan}}年 | 职位性质：{{item.work_type}} 
						</div>

						<div
							style="width: 150px;height: 40px;border: 1px solid #D7230C;border-radius: 5px;line-height: 40px;text-align: center;font-weight: 800;color: #D7230C;position: absolute;right: 10px;bottom: 50px;">
							查看简历
						</div>
					</router-link>
				</div>
				<div style="width: 100%;height: 50px;margin-top: 15px;text-align: center;">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next"
						:total="Totals"></el-pagination>
				</div>
			</div>


		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				options: [{
						value: '职位',
						label: '职位'
					},
					{
						value: '人才',
						label: '人才'
					}
				],
				citys: [],
				provs: [{
						label: "北京市",
						value: "北京市"
					},
					{
						label: "天津市",
						value: "天津市"
					},
					{
						label: "河北省",
						value: "河北省"
					},
					{
						label: "山西省",
						value: "山西省"
					},
					{
						label: "内蒙古自治区",
						value: "内蒙古自治区"
					},
					{
						label: "辽宁省",
						value: "辽宁省"
					},
					{
						label: "吉林省",
						value: "吉林省"
					},
					{
						label: "黑龙江省",
						value: "黑龙江省"
					},
					{
						label: "上海市",
						value: "上海市"
					},
					{
						label: "江苏省",
						value: "江苏省"
					},
					{
						label: "浙江省",
						value: "浙江省"
					},
					{
						label: "安徽省",
						value: "安徽省"
					},
					{
						label: "福建省",
						value: "福建省"
					},
					{
						label: "江西省",
						value: "江西省"
					},
					{
						label: "山东省",
						value: "山东省"
					},
					{
						label: "河南省",
						value: "河南省"
					},
					{
						label: "湖北省",
						value: "湖北省"
					},
					{
						label: "湖南省",
						value: "湖南省"
					},
					{
						label: "广东省",
						value: "广东省"
					},
					{
						label: "广西壮族自治区",
						value: "广西壮族自治区"
					},
					{
						label: "海南省",
						value: "海南省"
					},
					{
						label: "重庆市",
						value: "重庆市"
					},
					{
						label: "四川省",
						value: "四川省"
					},
					{
						label: "贵州省",
						value: "贵州省"
					},
					{
						label: "云南省",
						value: "云南省"
					},
					{
						label: "西藏自治区",
						value: "西藏自治区"
					},
					{
						label: "陕西省",
						value: "陕西省"
					},
					{
						label: "甘肃省",
						value: "甘肃省"
					},
					{
						label: "青海省",
						value: "青海省"
					},
					{
						label: "宁夏回族自治区",
						value: "宁夏回族自治区"
					},
					{
						label: "新疆维吾尔自治区",
						value: "新疆维吾尔自治区"
					},
					{
						label: "台湾省",
						value: "台湾省"
					},
					{
						label: "香港特别行政区",
						value: "香港特别行政区"
					},
					{
						label: "澳门特别行政区",
						value: "澳门特别行政区"
					}
				],
				area:'',
				city:'',
				city:'',
				province:'',
				province:'',
				tags: [],	
				dwgmData:'',
				keyword: '',
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				currentPage: 1, //当前页
				pageSize: 8, //当前每页数据
				Totals: 8, //总数据条数
				dabing: '',
				gzxzData:'',
				xlyqData:'',
				gzjyData:'',
				gxsjData:'',
				selectCity:'',
				zhpxData:'',
				// 筛选
				selectchildList: [
					{
						id: 1,
						title: '单位规模',
						options: [
							{
								value: '不限',
								label: '不限'
							},
							{
								value: '私营',
								label: '私营'
							},
							{
								value: '国有',
								label: '国有'
							},
							{
								value: '股份制',
								label: '股份制'
							},
							{
								value: '外商独资/办事处',
								label: '外商独资/办事处'
							},
							{
								value: '中外合资/合作',
								label: '中外合资/合作'
							},
							{
								value: '上市公司',
								label: '上市公司'
							},
							{
								value: '事业单位',
								label: '事业单位'
							},
							{
								value: '政府机关',
								label: '政府机关'
							},
							{
								value: '非营利机构',
								label: '非营利机构'
							}
						]
					},
					{
						id: 2,
						title: '工作性质',
						options: [
							{
								value: '全职',
								label: '全职'
							},
							{
								value: '兼职',
								label: '兼职'
							},
							{
								value: '实习',
								label: '实习'
							}
						]
					},
					{
						id: 3,
						title: '学历要求',
						options: [
							{
								value: '无要求',
								label: '无要求'
							},
							{
								value: '专科',
								label: '专科'
							},
							{
								value: '本科',
								label: '本科'
							},
							{
								value: '硕士',
								label: '硕士'
							},
							{
								value: '博士',
								label: '博士'
							}
						]
					},
					{
						id: 4,
						title: '工作经验',
						options: [
							{
								value: '1年以内',
								label: '1年以内'
							},
							{
								value: '1-3年',
								label: '1~3年'
							},
							{
								value: '3-5年',
								label: '3~5年'
							},
							{
								value: '5-10年',
								label: '5~10年'
							},
							{
								value: '10年以上',
								label: '10年以上'
							}
						]
					},
					{
						id: 5,
						title: '更新时间',
						options: [
							{
								value: '最新时间',
								label: '最新时间'
							}
						]
					},
					{
						id: 5,
						title: '招聘职位选项',
						options: [
							{
								value: '106',
								label: '船体结构主管/建造/工程'
							},
							{
								value: '105',
								label: '船体工程师'
							},{
								value: '16',
								label: '轮机'
							},
							{
								value: '108',
								label: '轮机主管/建造/工程'
							},
							{
								value: '109',
								label: '轮机设计'
							},
							{
								value: '107',
								label: '轮机工程师/轮机员'
							},
							{
								value: '18',
								label: '船舶与海洋工程设计类'
							},
							{
								value: '114',
								label: '放样工程师/技术员'
							},
							{
								value: '115',
								label: '造船及海洋平台'
							},
							{
								value: '116',
								label: '内装设计师'
							},
							{
								value: '117',
								label: '电气工程师'
							},
							{
								value: '118',
								label: '审图工程师'
							},
							{
								value: '119',
								label: '机械工程师'
							},
							{
								value: '120',
								label: '船舶设计'
							},
							{
								value: '111',
								label: '设计管理'
							},
							{
								value: '112',
								label: '舾装工程师'
							},
							{
								value: '113',
								label: '船体/结构设计'
							},
							{
								value: '110',
								label: '舶电气设计'
							},
							{
								value: '121',
								label: '其它分类'
							},
							{
								value: '122',
								label: '舾（内）装'
							},
							{
								value: '123',
								label: '机电类'
							},
							{
								value: '125',
								label: '模具工程师'
							},
							{
								value: '126',
								label: '机电工程师'
							},
							{
								value: '127',
								label: '铸造/锻造工程师'
							},
							{
								value: '128',
								label: '注塑/吹塑工程师'
							},
							{
								value: '129',
								label: 'CNC/数控工程师'
							},
							{
								value: '130',
								label: '冲压工程师/技师'
							},
							{
								value: '131',
								label: '刀具工程师'
							},
							{
								value: '132',
								label: '夹具工程师/技师'
							},
							{
								value: '133',
								label: '仪表/计量工程师'
							},
							{
								value: '134',
								label: '变压/变频工程师'
							},
							{
								value: '135',
								label: '机械绘图师'
							},
							{
								value: '136',
								label: '焊接工程师'
							},
							{
								value: '137',
								label: '机械设计工程师'
							},
							{
								value: '138',
								label: '制造工程师'
							},
							{
								value: '124',
								label: '涂装'
							},
							{
								value: '139',
								label: '油漆代表'
							},
							{
								value: '140',
								label: '涂装主管/建造/工程'
							},{
								value: '141',
								label: '其他'
							}
						]
					}
				],
			}
		},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`每页 ${val} 条`);
			},
			gzxzDataselect(val) {
				this.select('工作性质', this.gzxzData);
				this.xlcx();
			},
			xlyqDataselect(val) {
				console.log(val)
				this.select('学历要求', this.xlyqData);
				this.xlcx();
			},
			gzjyDataselect(val) {
				console.log(val)
				this.select('工作经验', this.gzjyData);
				this.xlcx();
			},
			gxsjDataselect(val) {
				this.select('更新时间', this.gxsjData);
				this.xlcx();
			},
			zhpxDataselect(val) {
				this.selectLb = val
				this.xlcx();
			},
			dwgmDataselect(val) {
				this.select('单位规模', this.dwgmData);
				this.xlcx();
			},
			async xlcx(){
				let res = await http.post('api/hr/job',{
					scope: this.dwgmData,
					work_type: this.gzxzData,
					xueli: this.xlyqData,
					jobexperience: this.gzjyData,
					fid:this.selectLb,
				})
				this.dabing = res.data.data
			},
			handleClose(tag) {
				console.log(tag)
				let zIndex = 9999;
				this.tags.forEach((item, index) => {
					console.log(item,index)
					if (item.title == tag.title) {
						zIndex = index;
					}
				});
				this.tags.splice(zIndex, 1);
				this.gotosb()
			},
			select(title, val) {
				// 综合函数
				let add = 999;
				this.tags.forEach((item, index) => {
					if (item.title == title) {
						add = index;
					}
				});
				if (add == 999) {
					let obj = {
						title: title,
						name: val,
						type: 'danger'
					};
					this.tags.push(obj);
				} else {
					this.tags[add].name = val;
				}
			},
			// 清除标签
			clearTag() {
				this.tags = [];
				this.selectAdressCity = '全国';
				this.selsecXZ = '';
				this.selsecXZ = '';
				this.dwgmData = '';
				this.gzxzData = '';
				this.xlyqData = '';
				this.gzjyData = '';
				this.gxsjData = '';
				this.qkcx()
			},
			async qkcx(){
				let res = await http.get('api/hr/job')
				this.dabing = res.data.data
			},
			qwqe() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('token') || null)
				if (loginInfo == null) {
					this.$router.push({
						path: '/login'
					})
				} else {
					this.$router.push({
						path: '/user'
					})
				}
			},
			async gotosb(){
				let res = await http.get('api/hr/job')
				this.dabing = res.data.data
			},
			onSelected(){
				
			},
			async sca(item) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personal_collection', {
					uid: loginInfo.id,
					title: item.title,
					picture: item.picture,
					pc_link: '/qzzpdetail??id=' + item.id + '&title=' + item.title,
					url_link: '/qzzpdetail?id=' + item.id + '&title=' + item.title,
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '收藏成功',
						type: 'success'
					});
				} else {
					this.$notify({
						title: '失败',
						message: res.data.msg,
						type: 'error'
					});
				}
			},
			getProv: function(prov) {
				let tempCity = [];
				this.citys = [];
				this.selectCity = '';
				let allCity = [{
						prov: "北京市",
						label: "北京市"
					},
					{
						prov: "天津市",
						label: "天津市"
					},
					{
						prov: "河北省",
						label: "石家庄市"
					},
					{
						prov: "河北省",
						label: "唐山市"
					},
					{
						prov: "河北省",
						label: "秦皇岛市"
					},
					{
						prov: "河北省",
						label: "邯郸市"
					},
					{
						prov: "河北省",
						label: "邢台市"
					},
					{
						prov: "河北省",
						label: "保定市"
					},
					{
						prov: "河北省",
						label: "张家口市"
					},
					{
						prov: "河北省",
						label: "承德市"
					},
					{
						prov: "河北省",
						label: "沧州市"
					},
					{
						prov: "河北省",
						label: "廊坊市"
					},
					{
						prov: "河北省",
						label: "衡水市"
					},
					{
						prov: "山西省",
						label: "太原市"
					},
					{
						prov: "山西省",
						label: "大同市"
					},
					{
						prov: "山西省",
						label: "阳泉市"
					},
					{
						prov: "山西省",
						label: "长治市"
					},
					{
						prov: "山西省",
						label: "晋城市"
					},
					{
						prov: "山西省",
						label: "朔州市"
					},
					{
						prov: "山西省",
						label: "晋中市"
					},
					{
						prov: "山西省",
						label: "运城市"
					},
					{
						prov: "山西省",
						label: "忻州市"
					},
					{
						prov: "山西省",
						label: "临汾市"
					},
					{
						prov: "山西省",
						label: "吕梁市"
					},
					{
						prov: "内蒙古自治区",
						label: "呼和浩特市"
					},
					{
						prov: "内蒙古自治区",
						label: "包头市"
					},
					{
						prov: "内蒙古自治区",
						label: "乌海市"
					},
					{
						prov: "内蒙古自治区",
						label: "赤峰市"
					},
					{
						prov: "内蒙古自治区",
						label: "通辽市"
					},
					{
						prov: "内蒙古自治区",
						label: "鄂尔多斯市"
					},
					{
						prov: "内蒙古自治区",
						label: "呼伦贝尔市"
					},
					{
						prov: "内蒙古自治区",
						label: "巴彦淖尔市"
					},
					{
						prov: "内蒙古自治区",
						label: "乌兰察布市"
					},
					{
						prov: "内蒙古自治区",
						label: "兴安盟"
					},
					{
						prov: "内蒙古自治区",
						label: "锡林郭勒盟"
					},
					{
						prov: "内蒙古自治区",
						label: "阿拉善盟"
					},
					{
						prov: "辽宁省",
						label: "沈阳市"
					},
					{
						prov: "辽宁省",
						label: "大连市"
					},
					{
						prov: "辽宁省",
						label: "鞍山市"
					},
					{
						prov: "辽宁省",
						label: "抚顺市"
					},
					{
						prov: "辽宁省",
						label: "本溪市"
					},
					{
						prov: "辽宁省",
						label: "丹东市"
					},
					{
						prov: "辽宁省",
						label: "锦州市"
					},
					{
						prov: "辽宁省",
						label: "营口市"
					},
					{
						prov: "辽宁省",
						label: "阜新市"
					},
					{
						prov: "辽宁省",
						label: "辽阳市"
					},
					{
						prov: "辽宁省",
						label: "盘锦市"
					},
					{
						prov: "辽宁省",
						label: "铁岭市"
					},
					{
						prov: "辽宁省",
						label: "朝阳市"
					},
					{
						prov: "辽宁省",
						label: "葫芦岛市"
					},
					{
						prov: "吉林省",
						label: "长春市"
					},
					{
						prov: "吉林省",
						label: "吉林市"
					},
					{
						prov: "吉林省",
						label: "四平市"
					},
					{
						prov: "吉林省",
						label: "辽源市"
					},
					{
						prov: "吉林省",
						label: "通化市"
					},
					{
						prov: "吉林省",
						label: "白山市"
					},
					{
						prov: "吉林省",
						label: "松原市"
					},
					{
						prov: "吉林省",
						label: "白城市"
					},
					{
						prov: "吉林省",
						label: "延边朝鲜族自治州"
					},
					{
						prov: "黑龙江省",
						label: "哈尔滨市"
					},
					{
						prov: "黑龙江省",
						label: "齐齐哈尔市"
					},
					{
						prov: "黑龙江省",
						label: "鸡西市"
					},
					{
						prov: "黑龙江省",
						label: "鹤岗市"
					},
					{
						prov: "黑龙江省",
						label: "双鸭山市"
					},
					{
						prov: "黑龙江省",
						label: "大庆市"
					},
					{
						prov: "黑龙江省",
						label: "伊春市"
					},
					{
						prov: "黑龙江省",
						label: "佳木斯市"
					},
					{
						prov: "黑龙江省",
						label: "七台河市"
					},
					{
						prov: "黑龙江省",
						label: "牡丹江市"
					},
					{
						prov: "黑龙江省",
						label: "黑河市"
					},
					{
						prov: "黑龙江省",
						label: "绥化市"
					},
					{
						prov: "黑龙江省",
						label: "大兴安岭地区"
					},
					{
						prov: "上海市",
						label: "上海市"
					},
					{
						prov: "江苏省",
						label: "南京市"
					},
					{
						prov: "江苏省",
						label: "无锡市"
					},
					{
						prov: "江苏省",
						label: "徐州市"
					},
					{
						prov: "江苏省",
						label: "常州市"
					},
					{
						prov: "江苏省",
						label: "苏州市"
					},
					{
						prov: "江苏省",
						label: "南通市"
					},
					{
						prov: "江苏省",
						label: "连云港市"
					},
					{
						prov: "江苏省",
						label: "淮安市"
					},
					{
						prov: "江苏省",
						label: "盐城市"
					},
					{
						prov: "江苏省",
						label: "扬州市"
					},
					{
						prov: "江苏省",
						label: "镇江市"
					},
					{
						prov: "江苏省",
						label: "泰州市"
					},
					{
						prov: "江苏省",
						label: "宿迁市"
					},
					{
						prov: "浙江省",
						label: "杭州市"
					},
					{
						prov: "浙江省",
						label: "宁波市"
					},
					{
						prov: "浙江省",
						label: "温州市"
					},
					{
						prov: "浙江省",
						label: "嘉兴市"
					},
					{
						prov: "浙江省",
						label: "湖州市"
					},
					{
						prov: "浙江省",
						label: "绍兴市"
					},
					{
						prov: "浙江省",
						label: "金华市"
					},
					{
						prov: "浙江省",
						label: "衢州市"
					},
					{
						prov: "浙江省",
						label: "舟山市"
					},
					{
						prov: "浙江省",
						label: "台州市"
					},
					{
						prov: "浙江省",
						label: "丽水市"
					},
					{
						prov: "安徽省",
						label: "合肥市"
					},
					{
						prov: "安徽省",
						label: "芜湖市"
					},
					{
						prov: "安徽省",
						label: "蚌埠市"
					},
					{
						prov: "安徽省",
						label: "淮南市"
					},
					{
						prov: "安徽省",
						label: "马鞍山市"
					},
					{
						prov: "安徽省",
						label: "淮北市"
					},
					{
						prov: "安徽省",
						label: "铜陵市"
					},
					{
						prov: "安徽省",
						label: "安庆市"
					},
					{
						prov: "安徽省",
						label: "黄山市"
					},
					{
						prov: "安徽省",
						label: "滁州市"
					},
					{
						prov: "安徽省",
						label: "阜阳市"
					},
					{
						prov: "安徽省",
						label: "宿州市"
					},
					{
						prov: "安徽省",
						label: "六安市"
					},
					{
						prov: "安徽省",
						label: "亳州市"
					},
					{
						prov: "安徽省",
						label: "池州市"
					},
					{
						prov: "安徽省",
						label: "宣城市"
					},
					{
						prov: "福建省",
						label: "福州市"
					},
					{
						prov: "福建省",
						label: "厦门市"
					},
					{
						prov: "福建省",
						label: "莆田市"
					},
					{
						prov: "福建省",
						label: "三明市"
					},
					{
						prov: "福建省",
						label: "泉州市"
					},
					{
						prov: "福建省",
						label: "漳州市"
					},
					{
						prov: "福建省",
						label: "南平市"
					},
					{
						prov: "福建省",
						label: "龙岩市"
					},
					{
						prov: "福建省",
						label: "宁德市"
					},
					{
						prov: "江西省",
						label: "南昌市"
					},
					{
						prov: "江西省",
						label: "景德镇市"
					},
					{
						prov: "江西省",
						label: "萍乡市"
					},
					{
						prov: "江西省",
						label: "九江市"
					},
					{
						prov: "江西省",
						label: "新余市"
					},
					{
						prov: "江西省",
						label: "鹰潭市"
					},
					{
						prov: "江西省",
						label: "赣州市"
					},
					{
						prov: "江西省",
						label: "吉安市"
					},
					{
						prov: "江西省",
						label: "宜春市"
					},
					{
						prov: "江西省",
						label: "抚州市"
					},
					{
						prov: "江西省",
						label: "上饶市"
					},
					{
						prov: "山东省",
						label: "济南市"
					},
					{
						prov: "山东省",
						label: "青岛市"
					},
					{
						prov: "山东省",
						label: "淄博市"
					},
					{
						prov: "山东省",
						label: "枣庄市"
					},
					{
						prov: "山东省",
						label: "东营市"
					},
					{
						prov: "山东省",
						label: "烟台市"
					},
					{
						prov: "山东省",
						label: "潍坊市"
					},
					{
						prov: "山东省",
						label: "济宁市"
					},
					{
						prov: "山东省",
						label: "泰安市"
					},
					{
						prov: "山东省",
						label: "威海市"
					},
					{
						prov: "山东省",
						label: "日照市"
					},
					{
						prov: "山东省",
						label: "莱芜市"
					},
					{
						prov: "山东省",
						label: "临沂市"
					},
					{
						prov: "山东省",
						label: "德州市"
					},
					{
						prov: "山东省",
						label: "聊城市"
					},
					{
						prov: "山东省",
						label: "滨州市"
					},
					{
						prov: "山东省",
						label: "菏泽市"
					},
					{
						prov: "河南省",
						label: "郑州市"
					},
					{
						prov: "河南省",
						label: "开封市"
					},
					{
						prov: "河南省",
						label: "洛阳市"
					},
					{
						prov: "河南省",
						label: "平顶山市"
					},
					{
						prov: "河南省",
						label: "安阳市"
					},
					{
						prov: "河南省",
						label: "鹤壁市"
					},
					{
						prov: "河南省",
						label: "新乡市"
					},
					{
						prov: "河南省",
						label: "焦作市"
					},
					{
						prov: "河南省",
						label: "濮阳市"
					},
					{
						prov: "河南省",
						label: "许昌市"
					},
					{
						prov: "河南省",
						label: "漯河市"
					},
					{
						prov: "河南省",
						label: "三门峡市"
					},
					{
						prov: "河南省",
						label: "南阳市"
					},
					{
						prov: "河南省",
						label: "商丘市"
					},
					{
						prov: "河南省",
						label: "信阳市"
					},
					{
						prov: "河南省",
						label: "周口市"
					},
					{
						prov: "河南省",
						label: "驻马店市"
					},
					{
						prov: "河南省",
						label: "省直辖县级行政区划"
					},
					{
						prov: "湖北省",
						label: "武汉市"
					},
					{
						prov: "湖北省",
						label: "黄石市"
					},
					{
						prov: "湖北省",
						label: "十堰市"
					},
					{
						prov: "湖北省",
						label: "宜昌市"
					},
					{
						prov: "湖北省",
						label: "襄阳市"
					},
					{
						prov: "湖北省",
						label: "鄂州市"
					},
					{
						prov: "湖北省",
						label: "荆门市"
					},
					{
						prov: "湖北省",
						label: "孝感市"
					},
					{
						prov: "湖北省",
						label: "荆州市"
					},
					{
						prov: "湖北省",
						label: "黄冈市"
					},
					{
						prov: "湖北省",
						label: "咸宁市"
					},
					{
						prov: "湖北省",
						label: "随州市"
					},
					{
						prov: "湖北省",
						label: "恩施土家族苗族自治州"
					},
					{
						prov: "湖北省",
						label: "省直辖县级行政区划"
					},
					{
						prov: "湖北省",
						label: "仙桃市"
					},
					{
						prov: "湖北省",
						label: "潜江市"
					},
					{
						prov: "湖北省",
						label: "天门市"
					},
					{
						prov: "湖北省",
						label: "神农架林区"
					},
					{
						prov: "湖南省",
						label: "长沙市"
					},
					{
						prov: "湖南省",
						label: "株洲市"
					},
					{
						prov: "湖南省",
						label: "湘潭市"
					},
					{
						prov: "湖南省",
						label: "衡阳市"
					},
					{
						prov: "湖南省",
						label: "邵阳市"
					},
					{
						prov: "湖南省",
						label: "岳阳市"
					},
					{
						prov: "湖南省",
						label: "常德市"
					},
					{
						prov: "湖南省",
						label: "张家界市"
					},
					{
						prov: "湖南省",
						label: "益阳市"
					},
					{
						prov: "湖南省",
						label: "郴州市"
					},
					{
						prov: "湖南省",
						label: "永州市"
					},
					{
						prov: "湖南省",
						label: "怀化市"
					},
					{
						prov: "湖南省",
						label: "娄底市"
					},
					{
						prov: "湖南省",
						label: "湘西土家族苗族自治州"
					},
					{
						prov: "广东省",
						label: "广州市"
					},
					{
						prov: "广东省",
						label: "韶关市"
					},
					{
						prov: "广东省",
						label: "深圳市"
					},
					{
						prov: "广东省",
						label: "珠海市"
					},
					{
						prov: "广东省",
						label: "汕头市"
					},
					{
						prov: "广东省",
						label: "佛山市"
					},
					{
						prov: "广东省",
						label: "江门市"
					},
					{
						prov: "广东省",
						label: "湛江市"
					},
					{
						prov: "广东省",
						label: "茂名市"
					},
					{
						prov: "广东省",
						label: "肇庆市"
					},
					{
						prov: "广东省",
						label: "惠州市"
					},
					{
						prov: "广东省",
						label: "梅州市"
					},
					{
						prov: "广东省",
						label: "汕尾市"
					},
					{
						prov: "广东省",
						label: "河源市"
					},
					{
						prov: "广东省",
						label: "阳江市"
					},
					{
						prov: "广东省",
						label: "清远市"
					},
					{
						prov: "广东省",
						label: "东莞市"
					},
					{
						prov: "广东省",
						label: "中山市"
					},
					{
						prov: "广东省",
						label: "潮州市"
					},
					{
						prov: "广东省",
						label: "揭阳市"
					},
					{
						prov: "广东省",
						label: "云浮市"
					},
					{
						prov: "广西壮族自治区",
						label: "南宁市"
					},
					{
						prov: "广西壮族自治区",
						label: "柳州市"
					},
					{
						prov: "广西壮族自治区",
						label: "桂林市"
					},
					{
						prov: "广西壮族自治区",
						label: "梧州市"
					},
					{
						prov: "广西壮族自治区",
						label: "北海市"
					},
					{
						prov: "广西壮族自治区",
						label: "防城港市"
					},
					{
						prov: "广西壮族自治区",
						label: "钦州市"
					},
					{
						prov: "广西壮族自治区",
						label: "贵港市"
					},
					{
						prov: "广西壮族自治区",
						label: "玉林市"
					},
					{
						prov: "广西壮族自治区",
						label: "百色市"
					},
					{
						prov: "广西壮族自治区",
						label: "贺州市"
					},
					{
						prov: "广西壮族自治区",
						label: "河池市"
					},
					{
						prov: "广西壮族自治区",
						label: "来宾市"
					},
					{
						prov: "广西壮族自治区",
						label: "崇左市"
					},
					{
						prov: "海南省",
						label: "海口市"
					},
					{
						prov: "海南省",
						label: "三亚市"
					},
					{
						prov: "海南省",
						label: "三沙市"
					},
					{
						prov: "海南省",
						label: "省直辖县级行政区划"
					},
					{
						prov: "海南省",
						label: "五指山市"
					},
					{
						prov: "海南省",
						label: "琼海市"
					},
					{
						prov: "海南省",
						label: "儋州市"
					},
					{
						prov: "海南省",
						label: "文昌市"
					},
					{
						prov: "海南省",
						label: "万宁市"
					},
					{
						prov: "海南省",
						label: "东方市"
					},
					{
						prov: "海南省",
						label: "定安县"
					},
					{
						prov: "海南省",
						label: "屯昌县"
					},
					{
						prov: "海南省",
						label: "澄迈县"
					},
					{
						prov: "海南省",
						label: "临高县"
					},
					{
						prov: "海南省",
						label: "白沙黎族自治县"
					},
					{
						prov: "海南省",
						label: "昌江黎族自治县"
					},
					{
						prov: "海南省",
						label: "乐东黎族自治县"
					},
					{
						prov: "海南省",
						label: "陵水黎族自治县"
					},
					{
						prov: "海南省",
						label: "保亭黎族苗族自治县"
					},
					{
						prov: "海南省",
						label: "琼中黎族苗族自治县"
					},
					{
						prov: "重庆市",
						label: "重庆市"
					},
					{
						prov: "四川省",
						label: "成都市"
					},
					{
						prov: "四川省",
						label: "自贡市"
					},
					{
						prov: "四川省",
						label: "攀枝花市"
					},
					{
						prov: "四川省",
						label: "泸州市"
					},
					{
						prov: "四川省",
						label: "德阳市"
					},
					{
						prov: "四川省",
						label: "绵阳市"
					},
					{
						prov: "四川省",
						label: "广元市"
					},
					{
						prov: "四川省",
						label: "遂宁市"
					},
					{
						prov: "四川省",
						label: "内江市"
					},
					{
						prov: "四川省",
						label: "乐山市"
					},
					{
						prov: "四川省",
						label: "南充市"
					},
					{
						prov: "四川省",
						label: "眉山市"
					},
					{
						prov: "四川省",
						label: "宜宾市"
					},
					{
						prov: "四川省",
						label: "广安市"
					},
					{
						prov: "四川省",
						label: "达州市"
					},
					{
						prov: "四川省",
						label: "雅安市"
					},
					{
						prov: "四川省",
						label: "巴中市"
					},
					{
						prov: "四川省",
						label: "资阳市"
					},
					{
						prov: "四川省",
						label: "阿坝藏族羌族自治州"
					},
					{
						prov: "四川省",
						label: "甘孜藏族自治州"
					},
					{
						prov: "四川省",
						label: "凉山彝族自治州"
					},
					{
						prov: "贵州省",
						label: "贵阳市"
					},
					{
						prov: "贵州省",
						label: "六盘水市"
					},
					{
						prov: "贵州省",
						label: "遵义市"
					},
					{
						prov: "贵州省",
						label: "安顺市"
					},
					{
						prov: "贵州省",
						label: "毕节市"
					},
					{
						prov: "贵州省",
						label: "铜仁市"
					},
					{
						prov: "贵州省",
						label: "黔西南布依族苗族自治州"
					},
					{
						prov: "贵州省",
						label: "黔东南苗族侗族自治州"
					},
					{
						prov: "贵州省",
						label: "黔南布依族苗族自治州"
					},
					{
						prov: "云南省",
						label: "昆明市"
					},
					{
						prov: "云南省",
						label: "曲靖市"
					},
					{
						prov: "云南省",
						label: "玉溪市"
					},
					{
						prov: "云南省",
						label: "保山市"
					},
					{
						prov: "云南省",
						label: "昭通市"
					},
					{
						prov: "云南省",
						label: "丽江市"
					},
					{
						prov: "云南省",
						label: "普洱市"
					},
					{
						prov: "云南省",
						label: "临沧市"
					},
					{
						prov: "云南省",
						label: "楚雄彝族自治州"
					},
					{
						prov: "云南省",
						label: "红河哈尼族彝族自治州"
					},
					{
						prov: "云南省",
						label: "文山壮族苗族自治州"
					},
					{
						prov: "云南省",
						label: "西双版纳傣族自治州"
					},
					{
						prov: "云南省",
						label: "大理白族自治州"
					},
					{
						prov: "云南省",
						label: "德宏傣族景颇族自治州"
					},
					{
						prov: "云南省",
						label: "怒江傈僳族自治州"
					},
					{
						prov: "云南省",
						label: "迪庆藏族自治州"
					},
					{
						prov: "西藏自治区",
						label: "拉萨市"
					},
					{
						prov: "西藏自治区",
						label: "昌都地区"
					},
					{
						prov: "西藏自治区",
						label: "山南地区"
					},
					{
						prov: "西藏自治区",
						label: "日喀则地区"
					},
					{
						prov: "西藏自治区",
						label: "那曲地区"
					},
					{
						prov: "西藏自治区",
						label: "阿里地区"
					},
					{
						prov: "西藏自治区",
						label: "林芝地区"
					},
					{
						prov: "陕西省",
						label: "西安市"
					},
					{
						prov: "陕西省",
						label: "铜川市"
					},
					{
						prov: "陕西省",
						label: "宝鸡市"
					},
					{
						prov: "陕西省",
						label: "咸阳市"
					},
					{
						prov: "陕西省",
						label: "渭南市"
					},
					{
						prov: "陕西省",
						label: "延安市"
					},
					{
						prov: "陕西省",
						label: "汉中市"
					},
					{
						prov: "陕西省",
						label: "榆林市"
					},
					{
						prov: "陕西省",
						label: "安康市"
					},
					{
						prov: "陕西省",
						label: "商洛市"
					},
					{
						prov: "甘肃省",
						label: "兰州市"
					},
					{
						prov: "甘肃省",
						label: "嘉峪关市"
					},
					{
						prov: "甘肃省",
						label: "金昌市"
					},
					{
						prov: "甘肃省",
						label: "白银市"
					},
					{
						prov: "甘肃省",
						label: "天水市"
					},
					{
						prov: "甘肃省",
						label: "武威市"
					},
					{
						prov: "甘肃省",
						label: "张掖市"
					},
					{
						prov: "甘肃省",
						label: "平凉市"
					},
					{
						prov: "甘肃省",
						label: "酒泉市"
					},
					{
						prov: "甘肃省",
						label: "庆阳市"
					},
					{
						prov: "甘肃省",
						label: "定西市"
					},
					{
						prov: "甘肃省",
						label: "陇南市"
					},
					{
						prov: "甘肃省",
						label: "临夏回族自治州"
					},
					{
						prov: "甘肃省",
						label: "甘南藏族自治州"
					},
					{
						prov: "青海省",
						label: "西宁市"
					},
					{
						prov: "青海省",
						label: "海东市"
					},
					{
						prov: "青海省",
						label: "海北藏族自治州"
					},
					{
						prov: "青海省",
						label: "黄南藏族自治州"
					},
					{
						prov: "青海省",
						label: "海南藏族自治州"
					},
					{
						prov: "青海省",
						label: "果洛藏族自治州"
					},
					{
						prov: "青海省",
						label: "玉树藏族自治州"
					},
					{
						prov: "青海省",
						label: "海西蒙古族藏族自治州"
					},
					{
						prov: "宁夏回族自治区",
						label: "银川市"
					},
					{
						prov: "宁夏回族自治区",
						label: "石嘴山市"
					},
					{
						prov: "宁夏回族自治区",
						label: "吴忠市"
					},
					{
						prov: "宁夏回族自治区",
						label: "固原市"
					},
					{
						prov: "宁夏回族自治区",
						label: "中卫市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "乌鲁木齐市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "克拉玛依市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "吐鲁番地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "哈密地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "昌吉回族自治州"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "博尔塔拉蒙古自治州"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "巴音郭楞蒙古自治州"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "阿克苏地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "克孜勒苏柯尔克孜自治州"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "喀什地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "和田地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "伊犁哈萨克自治州"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "塔城地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "阿勒泰地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "自治区直辖县级行政区划"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "石河子市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "阿拉尔市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "图木舒克市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "五家渠市"
					},
					{
						prov: "台湾省",
						label: "台北市"
					},
					{
						prov: "台湾省",
						label: "高雄市"
					},
					{
						prov: "台湾省",
						label: "基隆市"
					},
					{
						prov: "台湾省",
						label: "台中市"
					},
					{
						prov: "台湾省",
						label: "台南市"
					},
					{
						prov: "台湾省",
						label: "新竹市"
					},
					{
						prov: "台湾省",
						label: "嘉义市"
					},
					{
						prov: "台湾省",
						label: "省直辖"
					},
					{
						prov: "香港特别行政区",
						label: "香港岛"
					},
					{
						prov: "香港特别行政区",
						label: "九龙"
					},
					{
						prov: "香港特别行政区",
						label: "新界"
					},
					{
						prov: "澳门特别行政区",
						label: "澳门半岛"
					},
					{
						prov: "澳门特别行政区",
						label: "澳门离岛"
					},
					{
						prov: "澳门特别行政区",
						label: "无堂区划分区域"
					}
				];
				for (var val of allCity) {
					if (prov == val.prov) {
						console.log(val.prov);
						this.select('省份', val.prov);
						this.province = val.prov
						tempCity.push({
							label: val.label,
							value: val.label
						})
					}
				}
				console.log(val.prov);
				this.citys = tempCity;
			},
			getCity: function(city) {
				console.log(city);
				this.city = this.selectCity
				this.select('城市', this.city);
				console.log(this.city)
			},
			async selectChild1() {
				if (this.keyword == '') {
					alert('请输入内容！')
					return
				}
				if (this.searchData.type == '人才') {
					let res = await http.post('api/Common/index', {
						model: 'hr',
						type: 'content',
						mid: '10',
						title: this.keyword
					})
					this.dabing = res.data.data.list.data
					this.Totals = res.data.data.list.total
					this.pageSize = res.data.data.list.per_page
					this.currentPage = res.data.data.list.current_page
				} else {
					let res = await http.post('api/Common/index', {
						model: 'hr',
						type: 'content',
						mid: '9',
						title: this.keyword
					})
					this.dabing = res.data.data.list.data
					this.Totals = res.data.data.list.total
					this.pageSize = res.data.data.list.per_page
					this.currentPage = res.data.data.list.current_page
				}
			}
		},
		mounted() {
			this.gotosb()
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),

		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		height: 1600px;
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}
	
	.cnmlgb /deep/ .el-tag--danger {
				background: #fff;
				margin-bottom: 8px;
				margin-right: 8px;
			}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}

	.Bigcosousuo {
		float: left;
		width: 300px;
		height: 36px;
		border: 1px solid #ececec;
		margin-left: 50px;
		background-color: #D7230C;
	}

	/deep/ .Bigcosousuo .el-input__inner {
		border-radius: 0px;
		border-right: none;
		height: 36px;
	}

	.Bigcosousuo>input {
		width: 50%;
		height: 34px;
		float: left;
		border: 0px;
		outline: none;
	}

	.Bigcosousuo>div {
		width: 20%;
		height: 36px;
		float: left;
		line-height: 36px;
		font-size: 20px;
		color: #FFF;
		font-weight: 800;
		text-align: center;
	}

	.rwdt_fb_0 {
		float: left;
		font-size: 17px;
		width: 110px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		margin-left: 50px;
		border: 1px solid #e82904;
		color: #e82904;
		border-radius: 4px;
		cursor: pointer;
	}

	.rwdt_fb {
		float: left;
		font-size: 17px;
		width: 110px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		margin-left: 20px;
		border: 1px solid;
		background-color: #e82904;
		color: #fff;
		border-radius: 4px;
		cursor: pointer;
	}

	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 1550px;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}
</style>
